import { setCookie } from 'utils/cookies';
import { getTimeZoneUtc } from 'utils/time-zone';

setCookie('timeZoneUtc', getTimeZoneUtc());
